import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/KinematicChain/1_1x.png`;
const Pic2 = `${FullPath}/KinematicChain/2_1x.png`;
const Pic3 = `${FullPath}/KinematicChain/3_1x.png`;
const Pic4 = `${FullPath}/KinematicChain/4_1x.png`;
const Pic5 = `${FullPath}/KinematicChain/5_1x.png`;
const Pic6 = `${FullPath}/KinematicChain/6_1x.png`;
const Pic7 = `${FullPath}/KinematicChain/7_1x.png`;



export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
  

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}